import React , {Component} from 'react';

import SectionCardList from '../../components/sections-list/sections-list.component';

class SectionPage extends Component{

  constructor(){
    super();
    this.state = {
        sections : [
            {
                "id": 0,
                "name": "أيسر التفاسير",
                "imglink": "/assets/sectionimg.png",
            },
            {
                "id": 1,
                "name": "تفسير بن كثير",
                "imglink": "/assets/sectionimg.png",
            },
            {
                "id": 2,
                "name": "تفسير الطبري",
                "imglink": "/assets/sectionimg.png",
            },
            {
                "id": 3,
                "name": "البداية والنهاية",
                "imglink": "/assets/sectionimg.png",
            },
            {
                "id": 4,
                "name": "الحديث",
                "imglink": "/assets/sectionimg.png",
            },
            {
              "id": 5,
              "name": "القرآن",
              "imglink": "/assets/sectionimg.png",
          }
        ]
    };
  }
  
  render(){
    const { sections } = this.state;
    
    return(
      <div >
        <h1>أقسام المكتبة</h1>
        <SectionCardList books={sections} />
        <br/><br/><br/><br/>
      </div>
    );
  }
}
export default SectionPage;